import React from 'react';

const cs3AssistantConversation = (
  <div className="space-y-4">
    {/* 1 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          The Pattern Recall Game involves remembering and replicating a sequence of patterns. The objective is to enhance memory skills while engaging participants in a mental exercise.
          <br /><br />
          Kindly allow me to explain the game step by step. First, a series of patterns will flash before you on the screen. Each pattern will appear briefly before transitioning to the next. Your task is to recall and reproduce the series once the display concludes.
          <br /><br />
          The game consists of multiple rounds, with each increasing in complexity as more patterns are added to the sequence. Please feel free to ask questions at any point, and I will provide assistance as needed.
          <br /><br />
          When ready, kindly indicate so, and the first round will commence.
        </div>
      </div>
    </div>
    {/* 2 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The Pattern Recall Game sounds fun and challenging! Let's get started. I'm ready for the first round.
        </div>
      </div>
    </div>
    {/* 3 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          The first round of the Pattern Recall Game will now begin. Please observe the screen carefully as the initial sequence of patterns is displayed. After viewing, you will be prompted to recall and replicate the sequence. Best of luck, and please do not hesitate to request clarification if needed.
        </div>
      </div>
    </div>
    {/* 4 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The first round sequence has been displayed. Please take a moment to recall the pattern. When you feel ready to replicate it, just say 'Ready,' and I'll guide you through recalling the sequence.
        </div>
      </div>
    </div>
    {/* 5 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thank you for patiently recalling the sequence. To replicate the pattern, please begin stating or inputting the sequence you recollect. If you require hints or assistance at any point, please feel free to request it. Proceed when you are ready.
        </div>
      </div>
    </div>
    {/* 6 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns were quite vibrant! Let me give it a try. Here we go...
        </div>
      </div>
    </div>
    {/* 7 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Excellent! Please proceed by stating or inputting the sequence you recall. If you encounter any difficulty or wish to confirm your input, do not hesitate to seek assistance. Once you have completed your attempt, I will provide feedback on the accuracy of the sequence. Good luck, and enjoy the process.
        </div>
      </div>
    </div>
    {/* 8 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns were quite vibrant! Let me give it a try. Here we go...
        </div>
      </div>
    </div>
    {/* 9 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Please proceed by stating or inputting the sequence you recall. If assistance is needed at any step, feel free to ask. Upon completion, I will provide feedback on the accuracy of your sequence. Enjoy the process and good luck.
        </div>
      </div>
    </div>
    {/* 10 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns were quite vibrant! Let me give it a try. Here we go...
        </div>
      </div>
    </div>
    {/* 11 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Fantastic! Please proceed by stating or inputting the sequence you recall. If you find yourself needing assistance or wishing to confirm your progression, do not hesitate to reach out. Once you have completed your attempt, I will provide feedback on its accuracy. I wish you the best of luck as you proceed, and remember to enjoy the exploration of your memory capabilities.
        </div>
      </div>
    </div>
    {/* 12 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns were quite vibrant! Let me give it a try. Here we go...
        </div>
      </div>
    </div>
    {/* 13 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Excellent! Begin by stating or inputting the sequence you recall. Should you encounter any challenges or seek confirmation of your recall, please feel free to ask for assistance. Once you have completed your attempt, I shall provide feedback regarding the accuracy of the sequence. Best of luck, and enjoy testing your memory!
        </div>
      </div>
    </div>
    {/* 14 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns were quite vibrant! Let me give it a try. Here we go: square, triangle, circle, and star. I hope I got them right!
        </div>
      </div>
    </div>
    {/* 15 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thank you for providing your sequence: square, triangle, circle, and star. I will now evaluate the accuracy of your recalled pattern. Please hold while I process this information.
          <br /><br />
          [After a brief pause]
          <br /><br />
          Upon review, the sequence you have provided is indeed correct! Excellent recall. Would you like to proceed to the next round, or do you have any questions or need a moment before continuing? Feel free to communicate your preference.
        </div>
      </div>
    </div>
    {/* 16 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The sequence was indeed correct! Let's keep the momentum going. I'm ready for the next round. These patterns really keep you on your toes!
        </div>
      </div>
    </div>
    {/* 17 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Wonderful! As we prepare to advance, please focus on the patterns that will shortly be presented on your screen. As the rounds progress, the complexity of the sequences will increase with the introduction of additional elements. Observe each pattern attentively, and allow yourself time to absorb the sequence thoroughly. Once the display concludes, you will have the opportunity to replicate the sequence. If any assistance is required, do not hesitate to reach out. Are you ready to continue with the upcoming round?
        </div>
      </div>
    </div>
    {/* 18 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns are keeping me engaged, RAVA! I'm ready to focus on the upcoming sequence. Let's see what's next in store for this round. I'm all set!
        </div>
      </div>
    </div>
    {/* 19 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          I am pleased to hear your enthusiasm for the challenge, and I assure you the experience will continue to be engaging. Please direct your attention to the screen as the sequence for the upcoming round will be displayed shortly. By focusing intently, you will optimize your chances of successfully recalling the new sequence. Once you have viewed the patterns, promptly indicate your readiness to proceed with the replication. If any assistance is required or if there are questions, feel free to inquire. Best of luck and enjoy this stimulating mental exercise.
        </div>
      </div>
    </div>
    {/* 20 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The patterns are keeping me engaged, RAVA! I'm ready to focus on the upcoming sequence. Let's see what's next in store for this round. I'm all set!
        </div>
      </div>
    </div>
  </div>
);

export default cs3AssistantConversation; 